import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

const FileItemStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    maxWidth: '100%',
    width: '550px',
  },
  errorMessage: {
    fontSize: '12px',
    color: '#f44336',
  },
  FileItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: palette.primary.light,
    padding: spacing(1.5, 2.5),
    borderRadius: '4px',
    boxShadow: 'none',
    border: 'none',
    width: '100%',
    cursor: 'pointer',
    '& .file-item-label-wrapper': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .download-icon': {
      display: 'inline-flex',
      width: '24px',
      height: '24px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& .file-item-label': {
      color: TextColors.light,
    },
    '& .file-item-icon': {
      maxWidth: '24px',
      height: 'auto',
      display: 'inline-block',
      margin: spacing(0, 1.5, 0, 0),
    },
  },
}));

export default FileItemStyles;
